import React from 'react';

import SubTitle from '../SubTitle';
import Title from '../Title';
import s from './index.module.css';

function SafariOverviewHeader({ title = 'Safari Overview', subTitle }) {
  return (
    <div className={s.header}>
      <Title text={title} />
      <div className={s.separator} />
      <SubTitle text={subTitle} />
    </div>
  );
}

export default SafariOverviewHeader;
